import { Injectable, inject } from '@angular/core';
import { Currency, CurrencyWithExchangeRate } from '@ceres/domain';
import { shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from '@ceres/frontend-helper';
import { ImpersonatedHttpClient } from './http/impersonated-http-client';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private readonly httpClient = inject(ImpersonatedHttpClient);
    private readonly environment = inject<{
        edgeService: string;
    }>(ENVIRONMENT);

    availableCurrencies$: Observable<CurrencyWithExchangeRate[]>;

    constructor() {
        const environment = this.environment;

        this.availableCurrencies$ = this.httpClient
            .get<CurrencyWithExchangeRate[]>(`${environment.edgeService}/currencies/active`)
            .pipe(shareReplay(1));
    }

    public compareCurrencies(currency1: Currency, currency2: Currency): boolean {
        return currency1 && currency2 ? currency1.code === currency2.code : currency1 === currency2;
    }
}
